module.exports = __webpack_public_path__ + "img/lock.62bbd420.png";